import { DeviceInfo } from 'qunar-react-native';
import { INDEX_2, INDEX_3, INDEX_4 } from './index-def';
export function evaluate() {
    const { model = '' } = DeviceInfo;
    if (['iPhone 7', 'iPhone 7 Plus'].includes(model)) {
        return {
            index: INDEX_3
        };
    }
    if ([
        'iPhone 5',
        'iPhone SE',
        'iPhone 6',
        'iPhone 6s',
        'iPhone 6 Plus',
        'iPad Mini 2'
    ].includes(model)) {
        return {
            index: INDEX_2
        };
    }
    return {
        index: INDEX_4
    };
}
